import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useCreateSchoolDivisonMutation, useGetSchoolDivisonDataQuery, useUpdateSchoolDivisonMutation } from "store/services/schoolsDivisons";
import useAutoUpdateInitialValues from "hooks/useAutoUpdateInitialValues";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { APPOINTMENT_SERVICES_LIST, SCHOOL_DIVISON_LIST } from "config/paths";
import { successMessageToast } from "helpers/common";
import { RequiredFieldAstrick } from "components/Common/Common";
import { useCreateAssessmentServicesMutation, useGetAssessmentServiceViewQuery, useUpdateAssessmentServicesMutation } from "store/services/assessmentServices";

const AddAppointmentServices = () => {
    const { id } = useParams();
    const editMode = !!id;
    const navigate = useNavigate();
    const divisonId = ""

    const { data: serviceData, isLoading: serviceDataLoading, isError: serviceDataError } = useGetAssessmentServiceViewQuery({ id }, { skip: !id });
    const [createService, { isLoading }] = useCreateAssessmentServicesMutation();
    const [updateService, { isLoading: updateServiceLoading }] = useUpdateAssessmentServicesMutation();
    const [initialValues, setInitialValues] = useState({ program_name: "", program_type: "" });

    useEffect(() => {
        if(serviceData){
            setInitialValues((prev) => ({...prev, program_name: serviceData?.program?.program_name, program_type: serviceData?.program?.program_type}))
        }
    }, [serviceData])

    const handleClickCancel = () => {
        navigate(APPOINTMENT_SERVICES_LIST);
    }

    const handleSubmit = async (values) => {
        const body = {
            program_name: values?.program_name,
            program_type: values?.program_name,
        }
        try {
            let result;
            if (editMode) {
                result = await updateService({
                  id,
                  body
                });
            } else {
                result = await createService({ body });
            }
            if (result.error) {
                console.error("Error creating service", result.error);
            } else {
                successMessageToast(result.data?.message || "Service created successfully");
                navigate(APPOINTMENT_SERVICES_LIST);
            }
        } catch (err) {
            console.log("Error creating service", err);
        }
    }

    return (
        <>
            <section className={`${styles.addForm} position-relative py-4 addForm`}>
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="pageHead pb-3 d-flex align-items-center">
                                <Link
                                    className="themeBlue fw-sbold back-to-btn"
                                    to={APPOINTMENT_SERVICES_LIST}
                                >
                                    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                    </svg> Back
                                </Link>
                                <h6 className="m-0 fw-bold themeBlue">
                                    Add New Service
                                </h6>
                            </div>
                        </Col>
                        <Col lg="12" className="my-2">
                            {serviceDataLoading ? (
                                <LoadingIndicator />
                            ) : serviceDataError ? (
                                <ErrorComponent />
                            ) : (
                                <Formik
                                    initialValues={initialValues}
                                    //   validationSchema={schoolDivisonFormSchema}
                                    onSubmit={handleSubmit}
                                    enableReinitialize
                                >
                                    {({
                                        handleSubmit
                                    }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <div
                                                className="py-3"
                                                style={{ borderTop: "1px solid #41a2a84d" }}
                                            >
                                                <Row>
                                                    <Col md="4" sm="6" className="my-2">
                                                        <label
                                                            htmlFor=""
                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                        >
                                                            Service Name
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name="program_name"
                                                            placeholder="Enter Service Name"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            <Row className="mt-4">
                                                <Col className="my-2" lg="12">
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <LoadingButton
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            isLoading={isLoading || updateServiceLoading}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                        <Button
                                                            onClick={handleClickCancel}
                                                            className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

const defaultInitialValues = {
    title: "",
    status: "active"
}

export default AddAppointmentServices;